<template>
  <div class="page">
      <!-- 背景图 -->
      <img class="item-img" :src="require('@/assets/LotteryInteractive/luckybg.png')" alt="">
      <LuckyWheel
        v-if="webLotteryForm==2"
        ref="myLucky"
        width="373px"
        height="373px"
        :prizes="prizes"
        :blocks="blocks"
        :default-config="defaultConfig"
        :buttons="buttons"
        @start="startCallback"
        @end="endCallback"
      />

      <LuckyGrid
        v-if="webLotteryForm==3"
        ref="myLucky"
        width="343px"
        height="343px"
        :prizes="prizes"
        :blocks="blocks2"
        :default-config="defaultConfig"
        :active-style="activeStyle"
        :buttons="buttons2"
        @start="startCallback"
        @end="endCallback"
      />

      <div class="guaguale-box" v-if="webLotteryForm==0">
        <img
          src="../../assets/interacactiveLottery/image 47.png"
          alt=""
          style="width: 90%"
        />
        <scratch-card
          v-if="isShow"
          elementId="scratch"
          width="13.2rem"
          height="2rem"
          :moveRadius="10"
          :ratio="0.1"
          :startCallback="startCallback2"
          :clearCallback="clearCallbackUp" 
          coverImg="https://download.zsvideo-data.com/opt/zhongshi/2022/06/21/guaguale_931272b4d8ff4b5786e0d1ab34514825_low.png"
          :result="result"
          style="
            position: absolute;
            top: 50.9%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 66%;
            height: 6.8rem;
          "
        >
        </scratch-card>
      </div>


      <div class="chance">您还有{{count}}次抽奖机会</div>

      <div class="bottom">
        {{detail.webLotteryTitle}}
        <div>活动时间：{{timeRange.webLotRoundStartTime}}至{{timeRange.webLotRoundEndTime}}</div>
      </div>
      <van-popup v-model="showModal" class="dialog-box">
      <div class="dialog-box-message">
        <div class="noaward" v-if="status==-1">
          <div>
            <img src="@/assets/invoice/noaward.png" alt="" />
          </div>
          <span style="font-size: 16px;">很遗憾奖品与您擦肩而过</span>
          <i class="close1" @click="changeShow"></i>
        </div>

        <div class="noaward" v-if="status==0">
          <div>
            <img src="@/assets/invoice/noaward.png" alt="" />
          </div>
          <span style="font-size: 16px;">很遗憾奖品已经派发完</span>
          <i class="close1" @click="changeShow"></i>
        </div>

        <div class="award" v-if="status==1">
          <span style="font-size: 16px;"> 恭喜你 中奖了!</span>
          <ul >
            <li >
              <img
                :src="prizeDetails.url"
                style="width: 200px"
              />
              <div  style="font-size: 18px;" >{{ prizeDetails.webLotPrizeTitle }}</div>
            </li>
          </ul>
          
          <i class="close" @click="changeShow"></i>
        </div>
      </div>
    </van-popup>

  </div>
</template>
<script>
 import { getDetail,getResidueDegree,lot,prizeDetail} from '@/api/lotteryInteractive'
import { filePerviewPath } from '@/api/ActivitySolicitation/index.js'
import scratchCard from "lzy-scratch-card";
import { Dialog, Toast } from "vant";

export default {
  components: {
    scratchCard,
  },
  data() {
      return {
          timeRange:{},
          showModal:false,
          status:-1,
          prizeDetails:{},
          detail:{},
          result: "", //遮罩层下面的页面（html）注：以html标签字符串的样式写
          isShow:true,
          blocks: [
            { padding: '30px',  background: '#FFA643',
            imgs: [{
              src: 'https://cbzs.zsvideo-data.com/image/wheelbg.png',
              width: '100%',
              height: '100%'
            }]}
          ],
          count:0,
          isInAnyTimeRange:{}, //轮次信息 
          defaultConfig:{gutter:3},
          prizes: [],
          webLotteryForm:0, //抽奖类型
          activeStyle:{background:'#FFBAA8'},
          blocks2: [
            { padding: '30px',  background: '#FFA643',
            imgs: [{
              src: 'https://cbzs.zsvideo-data.com/image/bg2.png',
              width: '100%',
              height: '100%'
            }]}
          ],
          buttons2: [
            {
              x: 1, y: 1,
              imgs: [{
                src: 'https://cbzs.zsvideo-data.com/image/begin2.png',
                width: '100%',
                height: '100%',
              }],
            },
          ],
          buttons: [
            {
              radius: '45%',
              imgs: [{
                src: 'https://cbzs.zsvideo-data.com/image/begin.png',
                width: '50%',
                top: '-80%'
              }]
            }
          ]

      }
  },
  mounted() {
    this.getActivityDetail();
  },
  methods: {
    changeShow() {
      this.showModal = false;
      this.getCount();
      // this.$nextTick(() => {
      //   document.querySelector(".select").innerHTML = "";
      // });
    },
    getCount(){
      getResidueDegree({webLotRoundId:this.isInAnyTimeRange.webLotRoundId,}).then(res => {
           if(res.data.code == 200){
            this.count=res.data.data;
          }else{
            Toast.fail(res.data.msg);
          }
        })
    },
    getBackImg(){
      let obj = {
      id: this.detail.backImgId,
      type: "cover"
    };
    console.log(obj)
      return filePerviewPath(obj);
    },
    getImgById(id){
      let obj = {
      id: id,
      type: "cover"
    };
    console.log(obj)
      return filePerviewPath(obj);
    },

     //刮刮乐刮层全部清除后的回调函数
     clearCallbackUp() {
      console.log('clearCallbackUp');
      // this.$refs.rulesOfGame.getLotUser();
      if (Object.keys(this.prizeDetails).length !== 0) {
        console.log(this.prizeDetails)
        this.result =
            `<img src=${this.prizeDetails.url} style='width:95%'/>`;
      } else {
        this.result =
          "<img src='https://download.zsvideo-data.com/opt/zhongshi/2022/07/28/ACgIABAEGAAgyYyK_QUorsqKWTCGBDjgAQ_3896c70a008b43a299f7bee29a973c6e_low.png' style='width:95%'/>";
      }
      setTimeout(() => {
        this.isShow = false;
        setTimeout(() => {
          this.isShow = true;
        }, 100);
      }, 2000);
    },

    //根据id获取奖品
    getPrizesById(id){
      prizeDetail({webLotPrizeId:id}).then(({data})=>{
        this.prizeDetails.url = filePerviewPath({
                  id: data.data.webLotPrizeImgId,
                  type: "cover",
                });
        this.prizeDetails.webLotPrizeTitle=data.data.webLotPrizeTitle
        console.log('prizeDetails',this.prizeDetails);
      })
    },
    startCallback2() {
      if (localStorage.getItem("token") == null && !this.IOS && !this.Android) {
        Dialog.confirm({
          message: "请登录后参与此活动。",
          title: "",
        })
          .then(() => {
            localStorage.setItem("path", this.$route.fullPath);
            this.$router.push({
              path: "/login",
              query: { webTenId: this.$route.query.webTenId },
            });
          })
          .catch(() => {
            this.isShow = false;
            setTimeout(() => {
              this.isShow = true;
            }, 300);
          });
      } else {
        if (localStorage.getItem("token") == null) {
          this.isShow = false;
          opneLoginPane();
          let timer = setInterval(() => {
            if (localStorage.getItem("token") != null) {
              clearInterval(timer);
              this.isShow = true;
            }
          }, 1000);
          return false;
        }
        if (this.count > 0) {
          const isInAnyTimeRange=this.getRoundInfo();
          if(!isInAnyTimeRange){
            Toast.fail("不在任何轮次活动的时间范围内");
            return;
          }
          lot({webLotteryId:this.$route.query.id,webLotteryRoundId:isInAnyTimeRange.webLotRoundId}).then(
            ({ data }) => {
              if(data.code==200){
                if (data.data >= 1) {  //1未中奖；0奖品已派完；1中奖不显示奖品；大于1为中奖并显示奖品id
                this.getPrizesById(data.data)
                } else if(data.data==0){
                  Toast.fail("奖品已派完");
                }else{
                  this.prizeDetails={};
                }
                this.getCount();
              }else{
                Toast.fail(data.msg);
              }
            }
          );
        } else {
          Toast.fail("您的抽奖次数为0");
          // this.$nextTick(() => {
          //   location.reload();
          // });
          this.isShow = false;
          setTimeout(() => {
            this.isShow = true;
          }, 300);
        }
      }
    },

     // 点击抽奖按钮会触发star回调
     startCallback () {
      const detail=this.detail
      //说明活动启动
      if(detail.rowStatus==1){
        if(detail.webLotteryStatus==0){  //未开始
          Toast.fail("该活动未开始");

        }else if(detail.webLotteryStatus==1){  //进行中
            // 调用抽奖组件的play方法开始游戏
            if (this.count == 0) {
              Toast.fail("您的抽奖次数为0");
              return
            }
            this.$refs.myLucky&&this.$refs.myLucky.play()
          //判断在哪个轮次里
          const isInAnyTimeRange=this.getRoundInfo();
          if(!isInAnyTimeRange){
            Toast.fail("不在任何轮次活动的时间范围内");
            return;
          }
          console.log('isInAnyTimeRange',isInAnyTimeRange)
          lot({webLotteryId:this.$route.query.id,webLotteryRoundId:isInAnyTimeRange.webLotRoundId}).then(({data}) => {
           if( data.code == 200){
            // 模拟调用接口异步抽奖
              setTimeout(() => {
                let index = 7
                // 假设后端返回的中奖索引是0
                if(data.data==-1){   //1未中奖；0奖品已派完；1中奖不显示奖品；大于1为中奖并显示奖品id
                  index= 7
                  //弹出未中奖
                  this.status=-1
                  this.showModal=true
                }else if(data.data>1){
                  this.status=1
                  this.getPrizesById(data.data)
                  this.showModal=true
                  //设置index
                  const prizes=isInAnyTimeRange.webLotteryPrizeEntityList;
                  const prizeIndex=prizes.findIndex(item=>item.webLotPrizeId==data.data);
                  prizeIndex==-1?index=7:index=prizeIndex;
                }else{
                  this.status=0
                  this.showModal=true
                }
                // 调用stop停止旋转并传递中奖索引
                this.$refs.myLucky&&this.$refs.myLucky.stop(index)
              }, 3000)
            }else{
              Toast.fail(res.data.msg);
            }
        })
          
        }else{
          Toast.fail("改活动已结束");
        }
      }else{
        Toast.fail("改活动未启动");
      }
    },
    getRoundInfo(){
      const currentTime = new Date().getTime();
      const roundInfo=this.detail.webLotteryRoundEntityList
      const isInAnyTimeRange = roundInfo.find(range => {
          const startTime = new Date(range.webLotRoundStartTime).getTime();
          const endTime = new Date(range.webLotRoundEndTime).getTime();
          return currentTime >= startTime && currentTime <= endTime;
      });
      
      if (isInAnyTimeRange) {
        
          console.log('当前时间在某个时间段内。');
          return isInAnyTimeRange;
      } else {
          console.log('当前时间不在任何时间段内。');
          return false;
      }
    },
    getPrizes(isInAnyTimeRange,type){
      if(isInAnyTimeRange){
        const prizes=isInAnyTimeRange.webLotteryPrizeEntityList;
        console.log('type',type)
        if(type==2){ //大转盘
          prizes.map((prize, index) => {
            this.prizes.push({ background: '#FF8622' ,imgs: [{
                  src: this.getImgById(prize.webLotPrizeImgId),
                  width: '50%',
                  top: '10%'
                }],fonts: [{ text: prize.webLotPrizeTitle,top:'75%' ,fontSize:'14px',fontColor: '#FFFFFF'}] })
          })
         //补全
        if(this.prizes.length!==8){
          const itemsToAdd = 8 - this.prizes.length;
            for (let i = 0; i < itemsToAdd; i++) {
              this.prizes.push({ background: '#FF8622' ,imgs: [{
                  src: 'https://cbzs.zsvideo-data.com/image/thanks.png',
                  width: '50%',
                  top: '10%'
                }],fonts: [{ text: '谢谢参与',top:'75%' ,fontSize:'14px',fontColor: '#FFFFFF'}] })
            }
          }
        }else if(type==3){  // 九宫格
          // 定义要填充的九宫格位置
            const positions = [
              [0, 0], [0, 1], [0, 2],
              [1, 0],         [1, 2],
              [2, 0], [2, 1], [2, 2]
            ];
          prizes.map((prize, index) => {
            this.prizes.push({ x:  positions[index][0], y: positions[index][1], imgs: [ {
                src: 'https://cbzs.zsvideo-data.com/image/bg2-block-transparent.png',
                width: '100%',
                height: '100%'
              },{
              src: this.getImgById(prize.webLotPrizeImgId),
              width: '60%',
              top: '10%',
            },] , fonts: [{ text: prize.webLotPrizeTitle, top: '60px',fontColor: '#BF3100',fontSize:'14px' }]}  )
          })
          //补全
          if(this.prizes.length!==8){
          const itemsToAdd = 8 - prizes.length;
            for (let i = 0; i < itemsToAdd; i++) {
              this.prizes.push({ x: positions[prizes.length+i][0] , y: positions[prizes.length+i][1], imgs: [{
                  src: 'https://cbzs.zsvideo-data.com/image/bg2-block-transparent.png',
                  width: '100%',
                  height: '100%'
                },{
                src: 'https://cbzs.zsvideo-data.com/image/thanks.png',
                width: '60%',
                top: '10%', 
              }],fonts: [{ text: '谢谢参与', top: '60px',fontColor: '#BF3100',fontSize:'14px' }] }  )
            }
          }

        }
       
      }
     
    },
    // 抽奖结束会触发end回调
    endCallback (prize) {
      console.log(prize)
    },
      getActivityDetail() {
        getDetail({webLotId:this.$route.query.id}).then(res => {
           if(res.data.code == 200){
            this.detail=res.data.data;
            this.webLotteryForm=this.detail.webLotteryForm;
            const isInAnyTimeRange=this.getRoundInfo();
            this.isInAnyTimeRange=isInAnyTimeRange
            this.getCount();
            this.timeRange.webLotRoundStartTime=isInAnyTimeRange.webLotRoundStartTime
            this.timeRange.webLotRoundEndTime=isInAnyTimeRange.webLotRoundEndTime
            this.getPrizes(isInAnyTimeRange,this.webLotteryForm);
          }
        })
      },
    
  }
}
</script>

<style scoped>

.guaguale-box {
  text-align: center;
  position: relative;
}
/deep/#scratchCanvas {
  width: 100%;
  height: 45%;
  top: 1.9rem;
}
/deep/.pic {
  display: flex;
  justify-content: center;
  align-items: center;
}


.bottom{
  width: 343px;
  height: 88px;
  background: #FFFBF1;
  border-radius: 10px 10px 10px 10px;
  z-index: 100;
  font-size: 16px;
  color:#BF3100;
  padding: 10px;
  margin-top: 20px;
}
.chance{
  width: 213px;
  height: 29px;
  background: #FC674F;
  border-radius: 29px 29px 29px 29px;
  text-align: center;
  color: #FFFFFF;
  z-index: 100;
  font-size: 16px;
  margin-top: 20px;
  line-height: 29px;
}
.dialog-box-message {
  width: 6rem;
  background-color: #eee;
  border-radius: 0.1rem;
  position: relative;
  height: 7.6rem;
  letter-spacing: 0.04rem;
  display: flex;
    justify-content: center;
    align-items: center;
}

.dialog-box-message .noaward {
  text-align: center;
  /* height: 5rem; */
  position: relative;
}
.dialog-box-message .close {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  bottom: -1.2rem;
  right: calc(50% - 0.4rem);
  background-image: url("../../assets/invoice/close.png");
  background-position: center;
  background-repeat: no-repeat;
}

.dialog-box-message .noaward > img {
  display: block;
  transform: scale(1.5);
  width: 3.5rem;
  height: 2.5rem;
  margin: 0 auto;
}
.dialog-box-message .award {
  height: 100%;
  background-position: 0.1rem center;
  /* height: 6rem; */
  padding: 0 0.4rem;
  padding-bottom: 0.2rem;
  text-align: center;
}
.close1 {
  width: 0.8rem;
  height: 0.8rem;
  position: absolute;
  bottom: -0.8rem;
  right: calc(50% - 0.4rem);
  color: #ccc;
  background-image: url("../../assets/invoice/close.png");
  background-position: center;
  background-repeat: no-repeat;
}

.page {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #781723;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.item-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.item-body {
  position: relative;
  top: 45px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  text-align: center;
}

.item-skip {
  position: absolute;
  top: 20px;
  right: 20px;
  font-family: Source Han Sans SC, Source Han Sans SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 3px 17px;
  border-radius: 48px;
  z-index: 1;
}

.dialog-box {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  /* left: 0;
  top: 0; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.body-title {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 18px;
  color: #F3DB9C;
}

.body-list {
  display: flex;
  align-items: center;
  margin: 12px 0;
  overflow-x: auto;
  /* 允许水平滚动 */
  white-space: nowrap;
  /* 防止内容换行 */

}

.item-box {
  height: 170px;
  overflow-y: auto;
}

.list-name {
  padding: 2px 12px;
  background: #FAECAF;
  border-radius: 12px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 12px;
  color: #A02120;
}

.list-text {
  margin-left: 20px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

.body-time {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 12px;
  color: #FFFFFF;
  margin: 10px 0;
}

.item-codeImg {
  position: absolute;
  left: 33px;
  bottom: 50px;
}

.codeImg {
  width: 68px;
  height: 68px;
}

.colon {
  display: inline-block;
  margin: 0 4px;
  color: #999999;
  font-size: 16px;
}

.block {
  display: inline-block;
  width: 22px;
  color: #000;
  font-size: 16px;
  text-align: center;
}

/* 弹窗 */
.item-pop {
  width: 100%;
}

.pop-box {
  width: 343px;
  height: 240px;
  bottom: 35px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
}

.pop-body {
  padding: 16px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.pop-title {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.pop-time {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 19px;
}

.timeText {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  margin-right: 12px;
}

.pop-btn {
  width: 241px;
  height: 44px;
  background: rgba(52, 124, 207, 0.5);
  border-radius: 49px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  line-height: 44px;
  margin-top: 20px;
}

.pop-bottom {
  display: flex;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  justify-content: center;

}

.bottom-text {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #666666;
}

.bottom-line {
  width: 1px;
  height: 15px;
  background: #D9D9D9;
  border-radius: 0px 0px 0px 0px;
  margin: 0 29px;
}

.item-liuPop {
  width: 290px;
  height: auto;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 20px;
}

.liuPop-title {
  display: flex;
  align-items: center;
}

.liuPop-btn {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.liuPop-cancel {
  width: 127px;
  height: 44px;
  background: #E9F3FF;
  border-radius: 32px 32px 32px 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #347CCF;
  line-height: 44px;
  text-align: center;
  margin-top: 40px;
}

.liuPop-submit {
  width: 127px;
  height: 44px;
  background: #347CCF;
  border-radius: 32px 32px 32px 32px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 44px;
  text-align: center;
  margin-top: 40px;
}

.liuPop-input {
  width: 270px;
  border-radius: 6px 6px 6px 6px;
  border: #E3E3E3 1px solid;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #999999;
  padding: 8px;
}
</style>